import { ReactElement, ReactNode } from "react";
import { Popover } from "antd";
import type { PopoverProps } from "antd";
import { BubbleContent } from "./bubble-content.tsx";

type UserBubbleProps = {
  userId?: string;
  children?: ReactNode;
  trigger?: PopoverProps["trigger"];
};

export const UserBubble = ({ userId, children, trigger }: UserBubbleProps) => {
  return (
    <Popover
      content={
        userId ? ((<BubbleContent userId={userId} />) as ReactElement) : null
      }
      trigger={trigger ?? ["click"]}
      placement="bottomLeft"
      classNames={{ root: "user-info-popover-container" }}
    >
      {children}
    </Popover>
  );
};
